import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

function PasswordIcon(props) {
  return (
    <SvgIcon viewBox="0 0 100 100" {...props}>
      <path
        d="M97.3,38.3H81V21.2C81,9.5,67.1,0,50,0S19,9.6,19,21.2v17.2H2.7c-1.5,0-2.7,0.8-2.7,1.9v46.5C0,94.1,8.1,100,18.1,100
			h63.6c10,0,18.3-5.8,18.3-13.1V40.2C100,39.2,98.8,38.3,97.3,38.3z M24.4,21.2c0-9.6,11.5-17.3,25.6-17.3s25.6,7.8,25.6,17.3v17.2
			H24.4V21.2z M94.6,86.9c0,5.1-5.8,9.1-12.7,9.1H18.1C11,96,5.4,91.9,5.4,86.9V42.3h89.2V86.9z"
      />
      <path
        d="M48,73.1v10.4c0,1.1,0.9,1.9,2,1.9s2-0.8,2-1.9V73.1c5.3-1,9.2-5.3,9.2-10.7c0-5.9-5.1-10.8-11.3-10.8
			c-6.2,0-11.3,4.8-11.3,10.8C38.7,67.8,42.7,72.2,48,73.1z M50,55.5c4.1,0,7.2,3.2,7.2,6.9c0,3.8-3.3,6.9-7.2,6.9s-7.2-3.2-7.2-6.9
			C42.8,58.7,45.9,55.5,50,55.5z"
      />
    </SvgIcon>
  );
}

export default PasswordIcon;
